
// File: components/renderer/drawEnemy.ts
import { Enemy } from "../types/entities";
import { drawStyle0, drawStyle1, drawStyle2, drawStyle3, drawStyle4, drawPracticeDummy } from "./enemy/styles";
import { drawPilotDemon, drawFemaleStaffDemon, drawMaleStaffDemon, drawWaterDemon, drawHeavyWaterDemon, drawSwiftWaterDemon } from "./enemy/staffDemons";

export const drawEnemy = (ctx: CanvasRenderingContext2D, e: Enemy) => {
  ctx.save();
  const cx = e.x + e.width / 2;
  const cy = e.y + e.height;
  ctx.translate(cx, cy);

  // Animation
  const bob = Math.sin(Date.now() / 200) * 2;
  const sway = Math.sin(Date.now() / 400) * 2 * (Math.PI / 180);
  
  ctx.translate(0, bob);
  ctx.rotate(sway);

  // Scale to fit height 180 (Base drawing is approx 180px tall)
  const scale = e.height / 180;
  ctx.scale(scale, scale);

  // --- FLASH EFFECT ---
  if (e.flashTimer > 0) {
    ctx.globalCompositeOperation = "source-atop";
    ctx.fillStyle = "white";
    ctx.fillRect(-50, -180, 100, 180);
    ctx.globalCompositeOperation = "source-over";
    ctx.globalAlpha = 0.5;
  }

  // --- STYLE SWITCHER ---
  switch (e.style) {
    case 0: drawStyle0(ctx); break;
    case 1: drawStyle1(ctx); break;
    case 2: drawStyle2(ctx); break;
    case 3: drawStyle3(ctx); break;
    case 4: drawStyle4(ctx); break;
    // New Staff Demons
    case 5: drawPilotDemon(ctx); break;
    case 6: drawFemaleStaffDemon(ctx); break;
    case 7: drawMaleStaffDemon(ctx); break;
    // Water Demons
    case 8: drawWaterDemon(ctx); break;       // Standard
    case 9: drawHeavyWaterDemon(ctx); break;  // Heavy
    case 10: drawSwiftWaterDemon(ctx); break; // Swift
    // Practice
    case 11: drawPracticeDummy(ctx); break;
    default: drawStyle0(ctx); break;
  }

  ctx.restore();
};
